<div class="component-container">
  <div class="component-header">
    <h2>Create New Director</h2>
  </div>
  <app-director-form
    [form]="form"
    submitButtonText="Create Director"
    (submit)="onSubmit()"
    (cancel)="onCancel()">
  </app-director-form>
</div>
